export default function PublicCatalogInfoModal({ isOpen, onClose, profile }) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h2 className="text-lg font-semibold text-slate-900">Informacion del Emprendedor</h2>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 transition"
            aria-label="Cerrar"
          >
            <svg className="w-5 h-5 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="px-6 py-5 space-y-4">
          <div>
            <h3 className="text-xl font-bold text-slate-900">
              {profile.displayName || profile.businessName}
            </h3>
            {profile.tagline && (
              <p className="mt-1 text-sm text-slate-500">{profile.tagline}</p>
            )}
          </div>

          {profile.tagline && (
            <div>
              <p className="text-sm font-medium text-slate-700 mb-1">Tagline</p>
              <p className="text-sm text-slate-600">{profile.tagline}</p>
            </div>
          )}

          {profile.description && (
            <div>
              <p className="text-sm font-medium text-slate-700 mb-1">Descripcion</p>
              <p className="text-sm text-slate-600 leading-relaxed">{profile.description}</p>
            </div>
          )}

          {(profile.contactPhone || profile.email) && (
            <div>
              <p className="text-sm font-medium text-slate-700 mb-1">Contacto</p>
              {profile.contactPhone && (
                <p className="text-sm text-slate-600">{profile.contactPhone}</p>
              )}
              {profile.email && (
                <p className="text-sm text-slate-600">{profile.email}</p>
              )}
            </div>
          )}

          <div className="pt-2 border-t border-slate-100">
            <p className="text-xs text-slate-400">/catalogo/{profile.slug}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
